import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { RestClientService } from './rest/rest-client.service';

@Injectable({
	providedIn: 'root',
})
export abstract class BaseTokenService {
	public isTokenExpired = new Subject<boolean>();

	protected abstract get apiUrl(): string;

	constructor(protected restClientService: RestClientService) {
		this.isTokenExpired.next(false);
	}

	public close(): Promise<void> {
		return this.restClientService.delete(`${this.apiUrl}/close`).toPromise();
	}

	public unlockUser2Fa<T = unknown>(code: T): Observable<void> {
		return this.restClientService.post(`${this.apiUrl}/unlock-user-2fa`, JSON.stringify(code));
	}

	public resend2Fa(): Observable<void> {
		return this.restClientService.get(`${this.apiUrl}/resend-user-2fa-code`);
	}
}
